import React, { useEffect } from 'react'
import { Grid } from '@mui/material'

import EditMappingDrawer from 'Pages/User/CustomMapping/EditDrawer'
import CreateCustomMappingButton from 'Pages/User/CustomMapping/CreateButton'
import { MAPPING_TYPE } from 'Pages/User/CustomMapping/@constants'
import CustomMappingTable from 'Pages/User/CustomMapping/Table'
import {clearSignals} from 'Pages/User/CustomMapping/@signals'
import UploadXlsButton from "./XlsUploadButton";
import UploadXlsTemplate from "./UploadXlsTemplate";

export default function CustomMappingPageContent() {

	useEffect(() => {
		return () => {
			clearSignals()
		}
	}, [])

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<EditMappingDrawer/>
		</Grid>
		<Grid item xs={12} >
			<CreateCustomMappingButton path={MAPPING_TYPE.ACRISS} />
			<UploadXlsButton path={MAPPING_TYPE.ACRISS} />
			<UploadXlsTemplate path={MAPPING_TYPE.ACRISS} />
		</Grid>
		<Grid item xs={12} sx={{ height: 650 }}>
			<CustomMappingTable path={MAPPING_TYPE.ACRISS} />
		</Grid>
		<Grid item xs={12}>
			<CreateCustomMappingButton path={MAPPING_TYPE.CATEGORY} />
			<UploadXlsButton path={MAPPING_TYPE.CATEGORY} />
			<UploadXlsTemplate path={MAPPING_TYPE.CATEGORY} />
		</Grid>
		<Grid item xs={12}>
			<CustomMappingTable path={MAPPING_TYPE.CATEGORY} />
		</Grid>
	</Grid>
}